<template>
    <el-dialog
        title="位置信息"
        v-model="dialogVisible"
        width="40%"
        height="600px"
        :before-close="handleClose"
       
        >
        <div class="ditu">
            <div id="map" style="width: 100%; height: 600px;"></div>
        </div>
        
    </el-dialog>
</template>
<script>
// import { ElMessage } from 'element-plus'
import {deviceDetails} from "@/assets/api/api.js"
import AMapLoader from "@amap/amap-jsapi-loader";
window._AMapSecurityConfig = {
          securityJsCode: 'f2269481aca2ae2acdcc9267ed73aa7c'
    }

export default {
    name: 'MapComponent',
    components: {
        
    },
    props: ['mapObj'],
    data() {

        return {
            map: null,
            dialogVisible: true,
            loading:false,
            title:'',
            form:{
                imei:'',
            },
            cardid:"",
            MyData:[],
            infoWindow: null
        }

    },
    created(){
        console.log(this.mapObj,'我是地图');
        this.initMap()
        this.getMapInfo()
    },
    mounted(){
        window.closeInfo = this.closeInfo
     
    },
    watch: {
        mapObj () {
            console.log('监听地图',this.mapObj);
        }
    },
    methods:{
      handleClose() {
            this.$emit('cMapClick')
      },
      initMap(MyData){
        AMapLoader.load({
          key: '4017c4d793ff24df61d0bc3f37ba10d1',
          version: '2.0',
          plugins: [
            'AMap.ToolBar',
            'AMap.Scale',
            "AMap.Geolocation", //定位控件，用来获取和展示用户主机所在的经纬度位置
            "AMap.Geocoder",
            'AMap.PlaceSearch',
            'AMap.AutoComplete'
             ],
        }).then((AMap) => {
           this.map = new AMap.Map('map', {
            zoom: 14, // 地图显示的缩放级别
            // center: [116.397428, 39.90923] // 地图中心点坐标
          });
            this.AddClick(MyData)
          
        //   this.getMapInfo()
          // 你可以在这里添加更多的地图功能和事件监听
        }).catch(e => {
          console.log(e);
        });
      },
      getMapInfo(){
            // this.deviceDetailsSearch()
            let params = {
                deviceId: this.mapObj.deviceId || null,
                imei:this.mapObj.imei,
                userId:this.mapObj.deviceId == '' ? null: JSON.parse(localStorage.getItem('user')).id
            }
            deviceDetails(params).then((res) => {
                  this.MyData = res.data.data
                  this.initMap(this.MyData) 
                //   this.AddClick(this.MyData)
                //   this.loading =false

            }).catch((err)=> {
                console.log(err);
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

            })  
        
        },
    AddClick(MyData){
      var position = new AMap.LngLat(MyData.lng1, MyData.lat1) //参数为经纬度
          let marker = new AMap.Marker({
            position:position,
            title:'终端位置'+Math.floor(Math.random() * 100) + 1,
          })

          this.map.clearMap()// 清除所有覆盖物（点标志）
          this.map.add(marker)// 添加点标志
          this.showInfoWindow(marker);//自定义信息窗体
          this.map.setCenter(position);//位置点显示在地图中间
          // marker.showInfoWindow()
          marker.on('click', (e) => {
            this.showInfoWindow(marker);//自定义信息窗体
        });
      },
    showInfoWindow(marker){ 
   
     this.infoWindow = new AMap.InfoWindow({
       // content: info.join(""),
       isCustom: true, //是否自定义信息窗体
       content:`<div style="background-color: white; padding: 10px 15px;width:300px; border-radius: 5px; font-size:15px;border: 1px solid #cccccc;"> 
                  <div style="font-weight: 700; margin-bottom: 10px; ">个人信息<botton onclick="closeInfo();" style="margin-left:68%;font-size:16px">×</botton></div> 
                  <div style="font-weight: 700;  margin-bottom: 8px; margin-right: 5px;">姓名:<span>${this.MyData.deviceName}</span></div> 
                  <div style="font-weight: 700;  margin-bottom: 8px; ">时间:<span>${this.MyData.lastUpdateTime}</span></div> 
                  <div style="font-weight: 700;  margin-bottom: 8px; ">imei:<span>${this.MyData.imei}</span></div> 
                  <div style="font-weight: 700; margin-bottom: 8px; ">本机号码:<span>${this.MyData.phoneNumber}</span></div> 
                  <div style="font-weight: 700;  margin-bottom: 8px; ">位置:<span>${this.MyData.address}</span></div> 
               </div>`,
       // 开启后点击不了地图上的任何位置
       // closeWhenClickMap: true,
       zIndex: 999,
       offset: new AMap.Pixel(16, -35),
   });
 //  this.infoWindow.open(this.map, marker.getPosition());
     this.infoWindow.open(this.map, marker.getPosition());

   },
   closeInfo() {
        this.infoWindow.close();
      },
      
    }
    }




</script>
<style  scoped lang="scss">
    .ditu{
            margin-top: 10px;
            width: 100%;
            height: 100%;
        }
    :deep() {
        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        // margin-left: 180px;
        

    }
    
    .el-form-item--small{
        width: 70% !important;
    }
    }
   
</style>